import { uploadImage, uploadDataUrl } from '../images/upload';

/**
 * Upload an image from File or data URL and return the storage objectPath.
 */
export async function uploadImageAsset(
  fileOrDataUrl: File | string,
  feature: string,
  ownerId?: string,
): Promise<string> {
  if (typeof fileOrDataUrl === 'string') {
    return uploadDataUrl(fileOrDataUrl, { feature, ownerId });
  }
  return uploadImage(fileOrDataUrl, { feature, ownerId, contentType: fileOrDataUrl.type });
}
